export default "/assets/images/filter-rookie-parents-box.png?b1e4e4ac1ceaf76fc75c8d3736e0a3b0";